import type {ContainerQueryObject} from '@Hooks/useContainerQuery';

export enum AiChatSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const AI_CHAT_SIZE_QUERY: ContainerQueryObject = {
  [AiChatSize.SMALL]: {maxWidth: 600},
  [AiChatSize.MEDIUM]: {minWidth: 601, maxWidth: 991},
  [AiChatSize.LARGE]: {minWidth: 992},
};

export const AI_CHAT_SIZE_ORDER: AiChatSize[] = [AiChatSize.SMALL, AiChatSize.MEDIUM, AiChatSize.LARGE];

export interface AiChatSizeState {
  size: AiChatSize;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isCompact: boolean;
}
